import React, { useEffect } from "react";
import './dashboard-cooler.css'
import { FaDropbox, FaExchangeAlt, FaHeartbeat, FaPlaneArrival, FaPlaneDeparture, FaRegLemon } from "react-icons/fa";

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// COMPONENTE REUTILIZABLE PARA LA GRÁFICA
const GraficaDona = ({ valores }) => {
    const ocupadoReal = valores[0];
    // Detectamos si se pasó de 100%
    const esExceso = ocupadoReal > 100;
    // Si es exceso, llenamos la dona al 100%, si no usamos los valores reales
    const dataVisual = esExceso ? [100, 0] : valores;
    // Definimos colores: Rojo sin bordes si es exceso, Naranja/Verde si no
    const colores = esExceso 
        ? ['#FF0000', '#FF0000'] // Todo rojo
        : ['#F97F29', '#1CB07E']; // Normal

  // DATOS EN DURO PARA EL TOOLTIP
  // El índice 0 corresponde a la parte Naranja, el 1 a la Verde
  const datosExtraTooltip = [
    { piezas: 109.00, peso: 669.00, label: "Ocupado" }, // Datos para la rebanada Naranja (índice 0)
    { label: "Disponible" }                             // Datos para la rebanada Verde (índice 1)
  ];

  const data = {
    labels: ['Ocupado', 'Disponible'],
    datasets: [
      {
        data: valores,
        backgroundColor: colores,
        borderColor: esExceso ? '#FF0000' : colores,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Para que se ajuste al div contenedor
    cutout: '50%', // El agujero de la dona
    plugins: {
      // Configuracion del plugin de etiquetas
      datalabels: {
        display: !esExceso,
        formatter: (value) => {
          return value + '%';
        },
        color: '#fff',
        font: {
          weight: 'bold',
          size: 12,
        },
      },
      // Ocultamos la leyenda
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true, // Habilitar tooltips al pasar el mouse
        callbacks: {
            title: () => null,
            label: function(context) {
                // 'context.dataIndex' nos dice si es la rebanada 0 (naranja) o 1 (verde)
                const index = context.dataIndex;
                const datosDataInfo = datosExtraTooltip[index];

                // Si es el índice 0 (color naranja), mostramos piezas y peso
                if (index === 0) {
                return [
                    ` Piezas: ${datosDataInfo.piezas.toFixed(2)}`,
                    ` Peso: ${datosDataInfo.peso.toFixed(2)}`
                ];
                } else {
                // Si es el índice 1 (verde), mostramos la disponibilidad
                return ` ${datosDataInfo.label}: ${context.formattedValue}%`;
                }
            }
        }
      }
    },
  };

  return <Doughnut data={data} options={options} />;
};

const DashboardCooler = () => {
    // Datos de prueba para los valores de las graficas
    const datosTotal = [133.4, 66.6];
    const datosCam1 = [66.7, 33.3];
    const datosCam2 = [27.7, 72.3];
    const datosCam3 = [5.7, 94.3];

    // Datos de prueba para la 1ra parte del dashboard
    const data = {
        per: 1250, // Perecedero
        pha: 450,  // Pharma
        oth: 300,  // Otros
        imp: 800,  // Importación
        exp: 950,  // Exportación
        tra: 250,  // Tránsitos
        all: 4000  // Total (Denominador)
    };

    const esExcesoDatosTotal = datosTotal[0] > 100;
    const esExcesoCam1 = datosCam1[0] > 100;
    const esExcesoCam2 = datosCam2[0] > 100;
    const esExcesoCam3 = datosCam3[0] > 100;
    const ocupadoRealDT = datosTotal[0];
    const ocupadoRealCam1 = datosCam1[0];
    const ocupadoRealCam2 = datosCam2[0];
    const ocupadoRealCam3 = datosCam3[0];

    // Funcion para calcular porcentajes
    const calculatePercentage = (value) => {
        // Evitamos división por cero si 'all' viene vacío
        if (!data.all || data.all === 0) return "0.00";
        
        const percentage = (value * 100) / data.all;
        return percentage.toFixed(2); // Esto hace lo mismo que number_format(x, 2)
    };

    return(
        <>
            <div className="container-fluid dashboard-cooler">
                <div className="row cooler-percentages">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaRegLemon className="percentage-icon" />
                                <span className="percentage-text">
                                    {calculatePercentage(data.per)}%
                                </span>

                                <span className="tooltip-text">Perecedero</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaHeartbeat className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.pha)}%
                                </span>

                                <span className="tooltip-text">Pharma</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaDropbox className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.oth)}%
                                </span>

                                <span className="tooltip-text">Otros</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaPlaneArrival className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.imp)}%
                                </span>

                                <span className="tooltip-text">Importación</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaPlaneDeparture className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.exp)}%
                                </span>

                                <span className="tooltip-text">Exportación</span>
                            </div>
                            <div className="col-3 percentage-container tooltip-custom">
                                <FaExchangeAlt className="percentage-icon" />
                                <span>
                                    {calculatePercentage(data.tra)}%
                                </span>

                                <span className="tooltip-text">Tránsitos</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row cooler-graphs mt-4">
                    <div className="col-3 cooler-graph">
                        <div className="tooltip-custom">
                            <h5>Espacio Total Cámaras</h5>
                            <span className="tooltip-text">Volumen: 76.67 m³</span>
                        </div>
                        <div className="row mt-3">
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Total</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Disponible</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container" style={{ position: 'relative', height: '170px', width: '170px', margin: '3.5rem auto 5.5rem auto' }}>
                            <GraficaDona valores={datosTotal} />
                            {esExcesoDatosTotal && (
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: 'black' // Color negro/gris como la imagen
                            }}>
                                100%
                            </div>
                            )}

                            {esExcesoDatosTotal && (
                                <div className="alert alert-danger mt-3 text-center p-2" role="alert" style={{ fontSize: '0.9rem', lineHeight: '1.2', width: '150%', position: 'relative', left: '50%', transform: 'translateX(-50%)' }}>
                                <strong>Capacidad superada,</strong><br/>
                                porcentaje real: {ocupadoRealDT.toFixed(2)} %
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <div className="tooltip-custom">
                            <h5>Cámara 1</h5>
                            <span className="tooltip-text">Volumen: 76.67 m³</span>
                        </div>
                        <div className="row mt-3">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container" style={{ position: 'relative', height: '170px', width: '170px', margin: '3.5rem auto 5.5rem auto' }}>
                            <GraficaDona valores={datosCam1} />
                            {esExcesoCam1 && (
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: 'black' // Color negro/gris como la imagen
                            }}>
                                100%
                            </div>
                            )}

                            {esExcesoCam1 && (
                                <div className="alert alert-danger mt-3 text-center p-2" role="alert" style={{ fontSize: '0.9rem', lineHeight: '1.2', width: '150%', position: 'relative', left: '50%', transform: 'translateX(-50%)' }}>
                                <strong>Capacidad superada,</strong><br/>
                                porcentaje real: {ocupadoRealCam1.toFixed(2)} %
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <div className="tooltip-custom">
                            <h5>Cámara 2</h5>
                            <span className="tooltip-text">Volumen: 76.67 m³</span>
                        </div>
                        <div className="row mt-3">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container" style={{ position: 'relative', height: '170px', width: '170px', margin: '3.5rem auto 5.5rem auto' }}>
                            <GraficaDona valores={datosCam2} />
                            {esExcesoCam2 && (
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: 'black'
                            }}>
                                100%
                            </div>
                            )}

                            {esExcesoCam2 && (
                                <div className="alert alert-danger mt-3 text-center p-2" role="alert" style={{ fontSize: '0.9rem', lineHeight: '1.2', width: '150%', position: 'relative', left: '50%', transform: 'translateX(-50%)' }}>
                                <strong>Capacidad superada,</strong><br/>
                                porcentaje real: {ocupadoRealCam2.toFixed(2)} %
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 cooler-graph">
                        <div className="tooltip-custom">
                            <h5>Cámara 3</h5>
                            <span className="tooltip-text">Volumen: 76.67 m³</span>
                        </div>
                        <div className="row mt-3">
                            <div className="col-6">
                                <p className="graph-title-2">Peso Ocupado</p>
                                <p className="graph-text-2">229.71 Kg</p>
                            </div>
                            <div className="col-6">
                                <p className="graph-title-2">Volumen Ocupado</p>
                                <p className="graph-text-2">229.71 m³</p>
                            </div>
                        </div>
                        {/* Contenedor de la gráfica */}
                        <div className="chart-container" style={{ position: 'relative', height: '170px', width: '170px', margin: '3.5rem auto 5.5rem auto' }}>
                            <GraficaDona valores={datosCam3} />
                            {esExcesoCam3 && (
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: 'black' // Color negro/gris como la imagen
                            }}>
                                100%
                            </div>
                            )}

                            {esExcesoCam3 && (
                                <div className="alert alert-danger mt-3 text-center p-2" role="alert" style={{ fontSize: '0.9rem', lineHeight: '1.2', width: '150%', position: 'relative', left: '50%', transform: 'translateX(-50%)' }}>
                                <strong>Capacidad superada,</strong><br/>
                                porcentaje real: {ocupadoRealCam3.toFixed(2)} %
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div class="status-grid">
                                <div class="cell">P1A - Ocup.</div>
                                <div class="cell disponible">P2A - Disp.</div>

                                <div class="cell">P1B - Ocup.</div>
                                <div class="cell">P2B - Ocup.</div>

                                <div class="cell">P1C - Ocup.</div>
                                <div class="cell">P2C - Ocup.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DashboardCooler;